export interface IBranding {
  id: string;
  name: string;
  isActive: boolean;
}

export function mapBrandingFromApi(
  b: {
    brandingId?: string;
    id?: string;
    name?: string;
    [key: string]: unknown;
  },
  index: number,
  activeBrandingId?: string | null,
): IBranding {
  const id = (b.brandingId ?? b.id ?? String(index)) as string;

  return {
    id,
    name: (b.name ?? 'Unnamed') as string,
    isActive: activeBrandingId ? id === activeBrandingId : index === 0,
  };
}

export interface IBrandingListModalProps {
  open: boolean;
  onClose: () => void;
  onLeaveBrandingMode: () => void;
  onCreateNew: () => void;
  brandings: IBranding[];
  brandingsLoading?: boolean;
  onToggleBranding: (id: string) => void;
  onEditBranding?: (id: string) => void;
  onCloneBranding?: (id: string) => void;
  onDeleteBranding?: (id: string) => void;
  currentBrandingId?: string | null;
}

export interface ICreateBrandingModalProps {
  open: boolean;
  onClose: () => void;
  onStartFromScratch: () => void;
  onCloneFromExisting: () => void;
  hasExistingBrandings?: boolean;
}
